// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ie4E","colBig":"styles_colBig__345J_","colSmall":"styles_colSmall__2lgKC"};